export default __webpack_public_path__ + "static/media/border2l.0029432f.png";